var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrandIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 8,
    fill: "#FF7A00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8943 29.1058L13.755 27.9665L14.3547 26.1675L11.2365 26.7672L15.434 19.9312L18.7321 19.3915C19.0319 18.7719 20.1353 17.0289 22.1501 15.0141C24.6686 12.4956 30.3053 9.73721 34.6827 9.31746C34.2629 13.6949 31.5046 19.3316 28.986 21.8501C26.9712 23.8649 25.2283 24.9683 24.6086 25.2681L24.0689 28.5661L17.233 32.7637L17.8326 29.6455L16.0337 30.2451L14.8943 29.1058ZM23.0495 19.2716C22.5859 19.7353 22.5859 20.487 23.0495 20.9506C23.5132 21.4143 24.2649 21.4143 24.7285 20.9506C25.1922 20.487 25.1922 19.7353 24.7286 19.2716C24.2649 18.808 23.5132 18.808 23.0495 19.2716ZM26.0478 16.2734C25.5841 16.737 25.5841 17.4887 26.0478 17.9524C26.5114 18.416 27.2631 18.416 27.7268 17.9524C28.1904 17.4887 28.1904 16.737 27.7268 16.2734C27.2631 15.8097 26.5114 15.8097 26.0478 16.2734Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.31762 34.6825C9.57746 33.7431 10.5049 31.4564 12.136 29.8254C12.9035 29.0578 13.775 29.5456 14.1148 29.8854C14.4546 30.2252 14.9423 31.0966 14.1748 31.8642C12.5437 33.4952 10.2571 34.4227 9.31762 34.6825Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandIcon);
export default __webpack_public_path__ + "static/media/brand-icon.974281de1c857b3ba2072b5f4d4d9acc.svg";
export { ForwardRef as ReactComponent };